exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-investors-allocate-components-Save-___style__total___2nnyh{margin:0}.web-flows-deal-investors-allocate-components-Save-___style__diff___1m4fY{color:#95989a}", ""]);

// exports
exports.locals = {
	"total": "web-flows-deal-investors-allocate-components-Save-___style__total___2nnyh",
	"diff": "web-flows-deal-investors-allocate-components-Save-___style__diff___1m4fY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/investors/allocate/components/Save/style.css
// module id = 1339
// module chunks = 0